import React, { useState } from 'react';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import { Controller, useForm } from 'react-hook-form';
import { AlertLabel, Input } from '../../../assets/styled/Element';
import { useSnackbar } from 'notistack';
import SearchBankWalletList from '../../../components/Search/SearchBankWalletList';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { TitleLabel } from '../../../components/Element/LabelInputForm';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function TransferPointToBankWallet(props) {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const [selectGroup, setSelectGroup] = useState();

   const onSubmit = async (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values);
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      const result = {
         bankWalletId: values.bankWalletId
            ? values.bankWalletId.data.walletId
            : null,
         pointAmount: values.pointAmount
            ? +reverseFormatNumber(values.pointAmount, 'en')
            : null,
      };
      // console.log(result);
      // Axios.post('/GSB/dashboard/wallet/TransferPointToBankWallet', result)
      //   .then((resp) => {
      //     console.log(resp);
      //     enqueueSnackbar('โอนคะแนนสำเร็จ!!', {
      //       variant: 'success',
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     enqueueSnackbar(
      //       `เกิดข้อผิดพลาด : ${err.response.data.errorAppMessageTh}`,
      //       {
      //         variant: 'error',
      //       },
      //     );
      //   })
      //   .finally(() => {
      //     sessionStorage.removeItem('value');
      //     setIsLoading(false);
      //   });
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>โอนคะแนน</Typography>
            </Box>
         </Box>
         <Box mx={1}>
            <form onSubmit={handleSubmit(onSubmit)}>
               <Box
                  display={'flex'}
                  alignItems={'flex-start'}
                  flexDirection={'column'}
                  fontSize={20}
                  width={'50%'}
               >
                  <Box display={'flex'} width={'100%'}>
                     <Grid container spacing={1}>
                        <Grid item xs={6}>
                           <TitleLabel>ชื่อกระเป๋า</TitleLabel>
                           <Controller
                              as={
                                 <SearchBankWalletList
                                    defaultOptions
                                    level={'4'}
                                 />
                              }
                              rules={{ required: true }}
                              onChange={([selected]) => selected}
                              name='bankWalletId'
                              control={control}
                           />
                        </Grid>
                        <Grid item xs={6}>
                           <TitleLabel>
                              จำนวนคะแนน
                              {errors.pointAmount && (
                                 <AlertLabel>กรุณาระบุคะแนน</AlertLabel>
                              )}
                           </TitleLabel>
                           <Controller
                              as={<Input textAlign={'right'} />}
                              rules={{ required: true }}
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name='pointAmount'
                              control={control}
                           />
                        </Grid>
                        <Grid item xs={12}>
                           <Box>
                              <Button
                                 variant='contained'
                                 color='primary'
                                 type={'submit'}
                              >
                                 ยืนยัน
                              </Button>
                           </Box>
                        </Grid>
                     </Grid>
                  </Box>
               </Box>
            </form>
         </Box>
      </Paper>
   );
}

export default TransferPointToBankWallet;
